module.exports = __webpack_public_path__ + "img/car-none-left.b2945cc0.jpg";